"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECOM_CART_SECTION_ID = exports.ECOM_APP_DEF_ID = exports.MEMBERS_AREA_SECTION_ID = exports.BOOKINGS_MEMBERS_AREA_WIDGET_ID = exports.SANTA_MEMBERS_APP_ID = exports.BOOKINGS_FORM_SECTION_ID = exports.BOOKINGS_CALENDAR_SECTION_ID = exports.BOOKINGS_SERVICE_PAGE_SECTION_ID = exports.BOOKINGS_LIST_SECTION_ID = exports.BOOKINGS_SCHEDULER_SECTION_ID = exports.BOOKINGS_CHECKOUT_SECTION_ID = exports.BOOKINGS_APP_DEF_ID = exports.RTL_LANGUAGES = exports.PRICING_PLAN_SECTION_ID = exports.PRICING_PLAN_APP_DEF_ID = void 0;
exports.PRICING_PLAN_APP_DEF_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';
exports.PRICING_PLAN_SECTION_ID = 'membership_plan_picker_tpa';
exports.RTL_LANGUAGES = ['ar', 'fa', 'he'];
exports.BOOKINGS_APP_DEF_ID = '13d21c63-b5ec-5912-8397-c3a5ddb27a97';
exports.BOOKINGS_CHECKOUT_SECTION_ID = 'book_checkout';
exports.BOOKINGS_SCHEDULER_SECTION_ID = 'scheduler';
exports.BOOKINGS_LIST_SECTION_ID = 'bookings_list';
exports.BOOKINGS_SERVICE_PAGE_SECTION_ID = 'Booking Service Page';
exports.BOOKINGS_CALENDAR_SECTION_ID = 'Booking Calendar';
exports.BOOKINGS_FORM_SECTION_ID = 'Booking Form';
exports.SANTA_MEMBERS_APP_ID = '14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9';
exports.BOOKINGS_MEMBERS_AREA_WIDGET_ID = '14edb332-fdb9-2fe6-0fd1-e6293322b83b';
exports.MEMBERS_AREA_SECTION_ID = 'bookings_member_area';
exports.ECOM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';
exports.ECOM_CART_SECTION_ID = 'shopping_cart';
//# sourceMappingURL=bookings.const.js.map